import { Injectable, inject } from '@angular/core';
import { SseClient } from 'ngx-sse-client';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SSE_Client {
  private client = inject(SseClient);

  public stream(url: string, keepAlive: boolean, body?: unknown, method = 'GET'): Observable<Event> {
    return this.client.stream(url, { keepAlive: keepAlive, reconnectionDelay: 8000 }, { body: body }, method);
  }
}
